export function getDeviceKey(width) {
    let device = 'desktop';
    if (width <= 980) return 'mobile';
    if (width > 980 && width <= 1400) return 'tablet';
    return device;
}
